import { createSelector, createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { LoadError, LoadFilter } from './models';
import { LoadState } from './reducer';

export interface LoadSelectors<Entity> {
  selectIds: MemoizedSelector<object, string[]>;
  selectEntities: MemoizedSelector<object, Entity[]>;
  selectError: MemoizedSelector<object, LoadError | null>;
  selectFilter: MemoizedSelector<object, LoadFilter>;
  selectLoading: MemoizedSelector<object, boolean>;
}

export function createLoadSelectors<Entity>(stateKey: string): LoadSelectors<Entity> {
  const selectLoadState = createFeatureSelector<LoadState<Entity>>(stateKey);
  const selectIndexedEntities = createSelector(selectLoadState, ({ entities }) => entities);
  const selectLoading = createSelector(selectLoadState, ({ loading }) => loading);
  const selectFilter = createSelector(selectLoadState, ({ filter }) => filter);
  const selectIds = createSelector(selectLoadState, ({ ids }) => ids);
  const selectError = createSelector(selectLoadState, ({ error }) => error);
  const selectEntities = createSelector(selectIds, selectIndexedEntities, (ids, entities) =>
    ids.map((id) => entities[id]),
  );

  return {
    selectError,
    selectFilter,
    selectEntities,
    selectIds,
    selectLoading,
  };
}
